export const formatLongDate = (dateIn: Date | null, language: string): string => {
    if (!dateIn) {
        return '';
    }
    const date = new Date(dateIn)
    const options: Object = { year: 'numeric', month: 'long', day: 'numeric' };
    const locale = language === 'en' ? 'en-US' : 'es-ES';
    const formattedDate = date.toLocaleDateString(locale, options);
    return formattedDate;
}

export const formatShortDate = (dateIn: Date | null | undefined, language: string): string => {
    if (!dateIn) {
        return '';
    }
    const date = new Date(dateIn);
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: '2-digit' };
    const locale = language === 'en' ? 'en-US' : 'es-ES';
    const formattedDate = date.toLocaleDateString(locale, options);
    return formattedDate;
}

export const formatTimeDate = (dateIn: Date | null, language: string): string => {
    if (!dateIn) {
        return '';
    }
    const date = new Date(dateIn);
    const options: Intl.DateTimeFormatOptions = { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    };
    const locale = language === 'en' ? 'en-US' : 'es-ES';
    const formattedDate = date.toLocaleDateString(locale, options);
    return formattedDate;
}
